import { Badge } from '@givebutter/primitives/badge';
import { faBuilding } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ContactType } from 'constants/contacts';
import { getContactNameDisplay } from 'customHooks/contactNameDisplay';
import { Contact } from 'types/domain';

interface SelectedContactDisplayProps {
    contact: Pick<
        Contact,
        'type' | 'first_name' | 'last_name' | 'primary_email' | 'primary_phone' | 'company_name'
    >;
}
const ContactOrCompanyLabel = ({ contact }: SelectedContactDisplayProps) => {
    const nameDisplay = getContactNameDisplay(contact);

    return contact.type === ContactType.Company ? (
        <span className="flex items-center gap-1">
            {contact.company_name ?? <span className="text-gray-400">N/A</span>}
            <Badge size="sm" color="primary">
                <FontAwesomeIcon icon={faBuilding} /> Company
            </Badge>
        </span>
    ) : (
        nameDisplay
    );
};

export { ContactOrCompanyLabel };
